<template>
	<!-- home -->
	<div class="home">
		<!-- <div class="left">
			<span class="text12 textcolorwhite">运维电话:4006111860</span>
		</div> -->
		<div class="right">
			<img src="@/assets/images/greenLife.svg"
				style="width:1.2rem;height: 1rem; padding:.6rem .5rem; margin-right: 3rem;" @click="toGreenLife()" />
			<!-- <img src="../assets/images/u415.png" style="width:1.2rem;margin:10px 8px;" @click="toScanCode()" /> -->
			<van-badge :content="$store.state.messageCount>0?$store.state.messageCount:''" max="99"
				style="width:1.2rem;height:1.2rem;margin: .5rem;top: -0.65rem;" @click.native="toMessageList()">
				<img src="@/assets/images/u414.png" style="width:1rem;heiht:1rem" />
			</van-badge>
		</div>
		<div class="content">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<div class="banner" @click="toTest()">
					<!-- <van-swipe style="height: 8rem;" :autoplay="5000"> -->
					<van-swipe style="width: 100%;aspect-ratio: 121/62;overflow: hidden;" :autoplay="5000">
						<van-swipe-item v-for="(image, index) in banners" :key="index">
							<!-- <img v-lazy="$baseurl.url+image.imageUrl" style="width:100%;height:8rem; fill" /> -->
							<img src="@/assets/images/banner_new.png"
								style="width:100%;height:100%; object-fit: cover;" />
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="todoList" style="margin-top: .5rem">
					<li @click="toContractManagmentPage(0)">
						<div class="number">{{actingCount}}</div>
						<div>待签约</div>
					</li>
					<li @click="toContractManagmentPage(1)">
						<div class="number">{{completedCount}}</div>
						<div>已完成</div>
					</li>
					<li @click="toContractManagmentPage(2)">
						<div class="number">{{cancelledCount}}</div>
						<div>已取消</div>
					</li>
				</div>
				<ul class="list" style="margin: .5rem 0 .5rem 0">
					<li v-for="item in list" :key="item.id" @click="jump(item)">
						<p class="item-t">
							<img :src="item.bg" />
							<!-- <i class="iconfont" style="object-fit: fill;" :style="{ backgroundImage: 'url(' + item.bg + ')' }"></i> -->
						</p>
						<p class="item-b" style="margin-top:.5rem">{{ item.title }}</p>
					</li>
				</ul>
				<div style="font-size:12px;margin:1rem 0 .5rem ;font-weight:900;"
					v-if="goStaffCertify||goCorpCertify||goCertDownload">使用引导</div>
				<!--消息-->
				<div class="notice" style="height: 3.2rem;" v-if="goStaffCertify">
					<div class="title">个人实名认证</div>
					<div class="content_">进行电子合同签署前，需要进行个人身份实名认证</div>
					<!-- <button class="more"
						:style="{'background-color':$store.state.userInfo.certifyWay===0?'#0277FC':'#7f7f7f'}"
						@click="toAuthSelf()">{{'去认证'}}</button> -->
					<button class="more"
						:style="{'background-color':$store.state.userInfo.certifyState===0?'#0277FC':'#7f7f7f'}"
						@click="toAuthSelf()">{{$store.state.userInfo.certifyState===0?'去认证':'已认证'}}</button>
				</div>
				<!--公告-->
				<div class="notice" style="height: 3.2rem;" v-if="goCorpCertify">
					<div class="title">企业实名认证</div>
					<div class="content_">个人身份认证完成后，需要进行企业实名认证</div>
					<button class="more"
						:style="{'background-color':$store.state.userInfo.certifyWay!=0?'#0277FC':'#7f7f7f'}"
						@click="toAuthEnterprise()">去认证</button>
				</div>
				<!--通知-->
				<div class="notice" style="height: 3.2rem;" v-if="goCertDownload">
					<div class="title">移动证书下载</div>
					<div class="content_">下载移动证书后方可进行电子合同签署</div>
					<button class="more"
						:style="{'background-color':$store.state.userInfo.certifyWay!=0?'#0277FC':'#7f7f7f'}"
						@click="toDownCert()">去下载</button>
				</div>
				<div style="font-size:12px;margin:1rem 0 .5rem ;font-weight:900;">推荐消息</div>
				<div class="notice notice_active" style="height: 3.7rem;" @click="toGuideDetails(1)">
					<img style="float:left;margin:0 .5rem .5rem .5rem;" src="../assets/images/u360.png">
					<div>
						<div class="title">如何快速进行企业认证</div>
						<div class="content_">用户想快速完成企业认证，需...</div>
						<div class="more_"></div>
					</div>
				</div>
				<div class="notice notice_active" style="height: 3.7rem;" @click="toGuideDetails(2)">
					<img style="float:left;margin:0 .5rem .5rem .5rem;" src="../assets/images/u367.png">
					<div>
						<div class="title">如何设置个人电子签名</div>
						<div class="content_">进行电子合同签名签，需要进行电...</div>
						<div class="more_"></div>
					</div>
				</div>
			</van-pull-refresh>
		</div>
		<!-- <van-popup v-model:show="auth_overlay_show" round closeable :style="{ width:'92%',}">
			<div class="auth_overlay_parent" @click.stop>
				<div class="auth_overlay_content">
					<p class="all_text text12">进行电子合同签约之前，您需要完成以下步骤：</p>
					<van-steps direction="vertical" active-color="#0277FC" :active="steps_active">
						<van-step v-for="(item,index) in steps" :key="index">
							<h2 class="all_text text14 textcolor333" style="font-weight: 900;">{{item.title}}</h2>
							<p class="all_text text12 textcolor999">{{item.content}}</p>
						</van-step>
					</van-steps>
					<button class="all_button text14" style="margin-top: .5rem;"
						@click="auth_dimiss()">进行个人实名认证</button>
				</div>
			</div>
		</van-popup> -->
		<van-dialog v-model="showDialog" title="系统公告" confirm-button-text="阅读全部内容后可关闭" confirm-button-color="#0277FC">
			<div class="all_text_center">
				<div class="horizontal_line margin_top_5"></div>
				<div class="margin_top_5 margin_bottom_5" style="max-height: 20rem;overflow-y: auto;padding: 0 1rem;">
					<div class="text16  font_weight_bold" v-html="dialogTitle"></div>
					<div class="text14 margin_top_5" v-html="dialogText"></div>
				</div>
			</div>
		</van-dialog>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Badge,
		Lazyload,
		Swipe,
		SwipeItem,
		PullRefresh,
		Dialog
	} from 'vant';
	Vue.use(Lazyload, {
		lazyComponent: true,
	});
	import {
		getBanner,
		getUserInfo
	} from '../utils/shareRequest'
	import {
		GETUPDATE,
	} from '../utils/http';
	import {
		getAppVersion,
		getDeviceType,
		updateAndroidApk,
		deleteExitFile
	} from '../utils/nativeOtherOperate.js'
	export default {
		name: "home",
		components: {
			[Badge.name]: Badge,
			[Lazyload.name]: Lazyload,
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[PullRefresh.name]: PullRefresh,
			[Dialog.Component.name]: Dialog.Component,
		},
		data() {
			return {
				//是否刷新
				refreshing: false,
				//认证步骤显示
				auth_overlay_show: false,
				//系统公告是否显示
				showDialog: false,
				//系统公告标题
				dialogTitle: '',
				//系统公告内容
				dialogText: '',
				//轮播图
				banners: [1, 2, 3],
				//icon导航
				list: [{
						icon: "icon222222",
						bg: require("@/assets/images/signature.png"),
						title: `速签`,
						id: "1",
						route: "/quicksignlist",
					},
					{
						icon: "iconconfigure_130",
						bg: require("@/assets/images/scan.png"),
						title: "扫一扫",
						id: "2",
						route: "/scancode",
					},
					{
						icon: "icontongzhi1",
						bg: require("@/assets/images/cert_manage.png"),
						title: "证书管理",
						id: "3",
						route: "/certlist",
					},
					{
						icon: "icondaiban",
						bg: require("@/assets/images/cunzheng_chayan.png"),
						title: "存证查验",
						id: "4",
						route: "/certificateverification",
					},
				],
				//认证状态 -1 0 1 2
				steps_active: -1,
				steps: [{
					title: '个人实名认证成功',
					content: '已完成个人实名认证',
					active_icon: '',
					inactive_icon: '',
				}, {
					title: '企业实名认证',
					content: '个人认证后，需要进行企业认证',
					active_icon: '',
					inactive_icon: '',
				}, {
					title: '移动证书下载',
					content: '个人认证后，需要进行企业认证',
					active_icon: '',
					inactive_icon: '',
				}],
				//待签名合同数
				actingCount: 0,
				//待盖章合同数
				completedCount: 0,
				//即将过期合同数
				cancelledCount: 0,
				//是否显示个人认证
				goStaffCertify: false,
				//是否显示企业认证
				goCorpCertify: false,
				//是否显示证书下载
				goCertDownload: false,
			};
		},
		activated() {
			console.log('window.location-=', window.location)
			getUserInfo()
			getBanner()
			this.getHomeInfo(); //获取待办数量
			if (!window.localStorage.getItem("HomeUrl") && window.plus && window.plus.os.name === 'Android') {
				this.checkUpdate()
			}
			//this.$Toast('刷新进入首页')
		},
		deactivated() {
			//console.log('home-deactivated')
		},
		//拦截设置keepalive是否缓存
		beforeRouteLeave(to, from, next) {
			//console.log("el-beforeRouteLeave", to, from);
			if (to.meta.index > from.meta.index) {
				if (from.meta.keepAlive) {
					this.$store.commit('addIndexKeepAlive', from.name);
				}
			} else {
				// if (from.meta.keepAlive) {
				// 	this.$store.commit('removeIndexKeepAlive', from.name);
				// }
			}
			//console.log(this.$store.state.indexKeepAlive)
			next();
		},
		mounted() {
			//const files = this.$route.query.files
			//this.$Toast('刷新进入首页'+files)
			//this.getBanners(); //获取轮播图
			//获取工具类
			sessionStorage.removeItem('selectedCorpId')
			this.Tool.getTools()
			if (this.$store.state.newquicksignfiles || this.$store.state.harmonysharefiles) {
				console.log('jump newquicksign 2')
				this.$store.dispatch(this.$LoadShow, true)
				setTimeout(() => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$router.push({
						path: '/newquicksign',
						query: {
							type: 0
						}
					})
				}, 1000)
			}
			if (this.$store.state.quickSignContractDetails) {
				console.log('jump contractdetails 2',this.$store.state.quickSignContractDetails)
				const info = this.$store.state.quickSignContractDetails
				const infos = JSON.parse(info)
				this.$store.dispatch(this.$LoadShow, true)
				setTimeout(() => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$router.push({
						path: '/contractdetails',
						query: {
							contractId: infos[0][0],
							contractStatus: infos[0][1],
						}
					})
				}, 1000)
			}
			this.getLatestNotice()
		},
		created() {},
		methods: {
			toTest() {
				// harmonyEsign.testPromise('12345678').then(res=>{
				// 	console.log('testPromise',res)
				// }).catch(err=>{
				// 	console.log('testPromise',err)
				// })
				// harmonyEsign.testFunction('aBcDeF1230zOn',(result)=>{
				// 	console.log('testFunction',result)
				// })
			},
			//碳积分
			toGreenLife() {
				this.$router.push({
					path: 'energyconservationcorplist',
				});
			},
			//签约数栏跳转签约列表
			toContractManagmentPage(index) {
				if (this.$store.state.userInfo.certifyState != 2) {
					this.$Toast('请先进行个人认证!')
					return
				}
				this.$router.replace({
					path: '/contractmanagement',
					query: {
						status: index,
					}
				})
			},
			//下载刷新
			onRefresh() {
				if (this.refreshing) {
					this.refreshing = false
				}
				getUserInfo()
				getBanner()
				this.getHomeInfo(); //获取待办数量
			},
			//个人认证
			toAuthSelf() {
				// this.$router.push({
				// 	path: 'personalauthflow',
				// });
				// return
				if (this.$store.state.userInfo.certifyState === 0) {
					this.$router.push({
						path: 'personalauthflow',
					});
				}
			},
			//企业认证
			toAuthEnterprise() {
				if (this.$store.state.userInfo.certifyState === 2) {
					this.$router.push({
						path: '/enterpriselist',
						query: {
							status: 2,
						}
					});
				}
			},
			//证书下载
			toDownCert() {
				if (this.$store.state.userInfo.certifyState === 2) {
					this.$router.push({
						path: 'certlist',
					});
				}
			},
			//跳转
			auth_dimiss() {
				if (this.steps_active === -1) {
					this.$router.push({
						path: 'personalauthflow',
					});
				} else if (this.steps_active === 0) {
					this.$router.push({
						path: 'enterpriselist',
					});
				} else if (this.steps_active === 1) {
					this.$router.push({
						path: 'certlist',
					});
				}
				this.auth_overlay_show = false;
			},
			//ICON导航跳转
			jump(item) {
				if (item.route === '/scancode' || item.route === '/quicksignlist') {
					if (item.route) {
						this.$router.push({
							path: item.route,
						});
					}
				} else {
					if (this.$store.state.userInfo.certifyState != 2) {
						this.$Toast('请先进行个人认证!')
						return
					}
					if (item.route) {
						this.$router.push({
							path: item.route,
						});
					}
				}
			},
			//跳转消息列表页面
			toMessageList() {
				// if (this.$store.state.messageCount > 0) {
				// 	this.$router.push({
				// 		path: '/newsList',
				// 	});
				// }
				this.$router.push({
					path: '/newsList',
				});
			},
			//跳转二维码扫描页面
			toScanCode() {
				if (!window.plus) {
					return
				}
				this.$router.push({
					path: '/scancode',
				});
			},
			//最新系统公告
			getLatestNotice() {
				this.$get("/notice/api/getLatestNotice")
					.then((res) => {
						if (res.success && res.data) {
							this.dialogTitle = res.data.noticeTitle
							this.dialogText = res.data.noticeText
							this.showDialog = true
						} else {
							this.showDialog = false
						}
					})
			},
			//轮播图
			getBanners() {
				//获取列表
				// this.$post('/message/api/notification/page', JSON.stringify({
				// 	current: 1,
				// 	size: 3,
				// })).then((res) => {
				// 	if (res.success && res.data) {
				// 		this.banners = res.data.records;
				// 	}
				// })
			},
			//推介消息
			toGuideDetails(type) {
				this.$router.push({
					path: "/guidedetails",
					query: {
						type: type,
					}
				});
			},
			//查看详情
			goDetails(item, title) {
				this.$router.push({
					path: "/newsDetails",
					query: {
						id: item.id,
						title: title,
					},
				});
			},
			//各种合同数量
			getHomeInfo() {
				this.$post("/home/api/getHome").then((res) => {
					if (res.success && res.data) {
						this.actingCount = res.data.summary.actingCount
						this.completedCount = res.data.summary.completedCount
						this.cancelledCount = res.data.summary.cancelledCount
						this.goStaffCertify = res.data.goStaffCertify
						this.goCorpCertify = res.data.goCorpCertify
						this.goCertDownload = res.data.goCertDownload
					}
				});
			},
			//检查升级
			checkUpdate() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$store.dispatch(this.$LoadText, '加载中...')
				let deviceType = getDeviceType() || 'android'
				let version = getAppVersion() || '3.0.1'
				// let deviceType = 'android'
				// let version = '3.0.1'
				GETUPDATE('/api/check', {
					name: 'esign',
					deviceType: deviceType,
					version: version
				}, {
					'X-AUTHEN-KEY': 'E5E867C210F845B89A8DEDCA56E45F95',
				}).then(res => {
					if (res.success && res.data && res.data.canUpdate) {
						this.popDownloadAndroidApk(res.data.url)
					} else {
						//this.$Toast('当前是最新版本！')
						this.$store.dispatch(this.$LoadShow, false)
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					console.log('check', err)
				})
			},
			//提示升级
			popDownloadAndroidApk(url) {
				let that = this
				Dialog.confirm({
						title: '提示',
						message: '存在比当前版本高的升级版本，点击确定开始下载，下载后进行升级。',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						that.downloadAndroidApk(url)
					})
					.catch(() => {
						this.$store.dispatch(this.$LoadShow, false)
					});
			},
			//下载升级
			downloadAndroidApk(url) {
				let time = Date.now()
				let that = this
				let fileName = '_downloads/update_' + time + '.apk'
				let aFileName = 'downloads/update_' + time + '.apk'
				this.$store.dispatch(this.$LoadText, '下载中...')
				let task = plus.downloader.createDownload(url, {
					filename: fileName,
				}, function(d, status) {
					that.$store.dispatch(that.$LoadShow, false)
					if (status === 200) {
						if (!updateAndroidApk(aFileName)) {
							that.$Toast('安装包升级失败，请重试！')
						}
					} else {
						that.$Toast('下载安装包失败，请重试！')
					}
				})
				task.start()
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../styles/global.css";

	.FFC125 {
		color: #FFC125;
	}

	.bbb {
		color: #bbb;
	}

	.home {
		position: relative;
		padding-top: 4rem;
		height: 100vh;

		.left {
			position: absolute;
			top: 2.5rem;
			left: 1rem;
			z-index: 10;
		}

		.right {
			position: absolute;
			top: 1.8rem;
			right: .5rem;
			z-index: 10;
		}

		.content {
			// position: relative;
			// padding: 0 0.5rem;
			// padding-bottom: 2.8rem;
			// width: 100%;
			// height: calc(100vh-4rem);
			overflow-y: auto;
			position: absolute;
			top: 4rem;
			left: 0;
			right: 0;
			bottom: 2.4rem;
			padding: 0 0.5rem;
			background: linear-gradient(180deg, #0277fc 3%, #0277fc 0, #eee 50%, #eee 100%);
			//overflow: auto;
		}

		// 修改下拉刷新字体颜色
		::v-deep .van-pull-refresh__head {
			color: white;
		}
	}

	.banner {
		width: 100%;
		margin-top: .5rem;
		overflow: hidden;
		border-radius: 0.3rem;
	}

	.todoList {
		display: flex;
		flex-wrap: wrap;
		border-radius: 0.3rem;
		background: #fff;

		li {
			position: relative;
			font-size: .6rem;
			width: 33.3%;
			text-align: center;
			overflow: hidden;
			font-weight: 900;
			line-height: 1.5rem;

			.number {
				font-size: 1.2rem;
				font-weight: 900;
				line-height: 2.5rem;
			}
		}
	}

	// .auth_overlay_parent {
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: center;
	// 	height: 100%;
	// }

	// .auth_overlay_content {
	// 	width: 90%;
	// 	background-color: #fff;
	// 	padding: 1rem .5rem;
	// 	border-radius: 0.3rem;
	// }

	.notice {
		background-color: #fff;
		border-radius: 0.3rem;
		font-size: 0.7rem;
		padding: 0.6rem 0 0.25rem 0;
		position: relative;
		margin-bottom: .5rem;

		.title {
			// border-left: 4pt solid #5265F4;
			text-indent: 0.5rem;
			font-weight: bold;
		}

		.content_ {
			font-weight: 500;
			font-size: .5rem;
			text-indent: 0.5rem;
			margin-top: 5px;
		}

		.more_ {
			width: 10px;
			height: 30px;
			background: url("../assets/images/u359.png") no-repeat;
			position: absolute;
			right: 1rem;
			top: 1.4rem;
			font-size: 2rem;
			font-weight: 900;
		}

		.more {
			font-size: 12px;
			position: absolute;
			right: .5rem;
			top: 0;
			display: inline-block;
			width: 70px;
			line-height: 1.2rem;
			margin-top: 1rem;
			border-radius: 50px;
			color: #fff;
			background-color: #0277FC;
		}

		.more:active {
			background-color: #0161b8;
		}

	}

	.notice_active:active {
		background-color: #f6f6f6;
	}

	.list {
		display: flex;
		flex-wrap: wrap;
		// background: #fff;
		border-radius: 0.3rem;
		padding: 0 0.5rem;

		li {
			position: relative;
			font-size: 0.7rem;
			// background: #fff;
			width: 25%;
			text-align: center;
			overflow: hidden;
			margin: 0.5rem 0;

			.item-t {
				// height: 2rem;
				width: 50%;
				background: #fff;
				border-radius: 50%;
				margin-left: 25%;
				// padding: 25%;
				aspect-ratio: 1;

				img {
					//margin-left: 25%;
					margin-top: 25%;
					// width: 1rem;
					height: 50%;
					object-fit: fill;
					aspect-ratio: 1;
				}

				// i {
				// 	background-position: center center;
				// 	background-repeat: no-repeat;
				// 	color: #fff;
				// 	font-size: 1.5rem;
				// 	display: inline-block;
				// 	height: 1rem;
				// 	width: 1rem;
				// }
			}
		}
	}
</style>